import { createAction } from 'redux-actions';
import { actionKey } from './constants';
export var updateMeasuredCookie = createAction("".concat(actionKey, "/UPDATE_COOKIE"), function (cookieType, cookieDim, dims) { return ({
    cookieType: cookieType,
    cookieDim: cookieDim,
    dims: dims,
}); });
export var initializeMeasuredCookie = createAction("".concat(actionKey, "/INIT"), function (cookies) { return ({ cookies: cookies }); });
//# sourceMappingURL=actions.js.map